import { render, staticRenderFns } from "./HomeAuthorSection.vue?vue&type=template&id=ec131c0e"
import script from "./HomeAuthorSection.vue?vue&type=script&lang=js"
export * from "./HomeAuthorSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports